export class MarkMessageUnresolvedRequest {
  private Action = 'MarkMessageUnresolved';
  public PublicToken: string;
  public MessageId: number;

  constructor({ PublicToken, MessageId }) {
    this.PublicToken = PublicToken;
    this.MessageId = MessageId;
  }
}
